import type { GetRoadmaps200Pagination } from './getRoadmaps200Pagination';
import type { GetRoadmaps200RoadmapsItem } from './getRoadmaps200RoadmapsItem';

export type GetRoadmaps200 = {
  /** 페이지네이션 정보 */
  pagination: GetRoadmaps200Pagination;
  /** 조회된 로드맵 목록 */
  roadmaps: GetRoadmaps200RoadmapsItem[];
};
